<script>
import { mapGetters } from 'vuex';
import { shuffle, map } from '../helpers.js';
import { setTimeout } from 'timers';
import CloudBubble from '../components/CloudBubble';
import LoadIndicator from '../components/LoadIndicator';

export default {
    name: 'QuestionCloud',
    components: {
        CloudBubble,
        LoadIndicator,
    },
    data: () => {
        return {
            questions: [],
            bubbleBaseSize: 392,
            positions: [],
            paddingTop: 60,
            paddingBottom: 60,
            numberOfBubbles: 8,
            bubbleMovementRadius: 4,
            minDepthSize: 0.2,
            maxDepthSize: 1,
            changeInterval: 20000,
            fadeOutTimeout: 1500,
            currentQuestions: [],
            isInizalized: false,
            mouseFocus: null,
        }
    },
    mounted() {
        this.init();
        window.onresize = () => {
            const area = this.$refs.cloudContainer.clientWidth * this.$refs.cloudContainer.clientHeight;
            if (area > 450000) {
                this.init();
            }
        }
    },
    methods: {
        init() {
            const area = this.$refs.cloudContainer.clientWidth * this.$refs.cloudContainer.clientHeight;
            switch (true) {
                case area < 350000:
                    if (this.$refs.cloudContainer.clientWidth < this.$refs.cloudContainer.clientHeight) {
                        this.positions = [
                            { x: 0.51, y: 0.132 },
                            { x: 0.51, y: 0.473 },
                            { x: 0.51, y: 0.815 },
                            { x: 0.2, y: 0.302 },
                            { x: 0.2, y: 0.644 },
                        ];
                    } else {
                        this.positions = [
                            { y: 0.25, x: 0.032 },
                            { y: 0.25, x: 0.373 },
                            { y: 0.25, x: 0.715 },
                            { y: 0.75, x: 0.202 },
                            { y: 0.75, x: 0.544 },
                        ];
                    }
                    this.numberOfBubbles = 4;
                    this.bubbleMovementRadius = 1.5;
                    this.minDepthSize = 0.5;
                    break;
                
                case area < 577000:
                    this.createPositions();
                    this.bubbleMovementRadius = 4;
                    this.bubbleBaseSize = 300;
                    break;
                
                case area < 790000:
                    this.createPositions();
                    this.bubbleMovementRadius = 4;
                    this.bubbleBaseSize = 319;
                    break;
                
                case area < 910000:
                    this.createPositions();
                    this.bubbleMovementRadius = 4;
                    this.bubbleBaseSize = 350;
                    break;
                
                case area < 914000:
                    this.createPositions();
                    this.bubbleMovementRadius = 4;
                    this.bubbleBaseSize = 365;
                    break;
                
                case area < 968000:
                    this.createPositions();
                    this.bubbleMovementRadius = 4;
                    this.bubbleBaseSize = 370;
                    break;

                default:
                    this.createPositions();
                    this.bubbleMovementRadius = 4;
                    this.bubbleBaseSize = 392;
                    break;
            
            }
            this.initCloud(this.allQuestions);
        },
        createPositions() {
            let positions = [];
            const xCorrdctionOffset = .12;
            const cols = Math.ceil(this.$refs.cloudContainer.clientWidth / (this.bubbleBaseSize * .8));
            const rows = Math.ceil(this.$refs.cloudContainer.clientHeight / (this.bubbleBaseSize * .4));

            for (let colI = 0; colI < cols - 1; colI++) {
                let colModulus = colI % 2;
                for (let rowI = 0; rowI < rows - 1; rowI++) {
                    if (rowI % 2 === colModulus) {
                        positions.push({ x: (1 / cols * (colI + 1)) - xCorrdctionOffset, y: 1 / rows * (rowI + 1) })
                    }
                }
            }

            this.positions = positions;
            this.numberOfBubbles = positions.length > 4 ? positions.length - 2 : 0;
        },
        initCloud(questions) {
            if (!questions || questions.length === 0) return;

            this.questions = [...questions];
            this.positions = [...shuffle(this.positions)];
            this.currentQuestions = [];

            if (!this.isInizalized) {
                setTimeout(() => {
                    this.updateQuestionList();
                }, this.changeInterval);
            }

            for (let i = 0; i < this.numberOfBubbles; i++) {
                let question = this.questions[0];

                if (question) {
                    const pos = this.positions[0];
                    question.pos = pos;
                    this.currentQuestions.unshift(question);
                    this.questions.splice(0, 1);
                    this.positions.splice(0, 1);
                }
            }
            
            this.isInizalized = true;
        },
        getBubblePos(pos, i) {
            pos = pos ? pos : this.muPositions[i];
            return {
                left: (pos.x * 100) + '%', 
                top: (pos.y * 100) + '%',
            }
        },
        getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        },
        updateQuestionList() {
            let leavingBubble = this.currentQuestions[0];
            let leavingPos = leavingBubble.pos;
            let enteringPos = this.positions[0];

            this.questions.push(leavingBubble);
            this.currentQuestions.splice(0, 1);
            this.positions.push(leavingPos);

            setTimeout(() => {
                let enteringQuestion = this.questions[0];
                enteringQuestion.pos = enteringPos;
                this.currentQuestions.push(enteringQuestion);
                this.questions.splice(0, 1);
                this.positions.splice(0, 1);
            }, this.fadeOutTimeout);

            setTimeout(() => {
                this.updateQuestionList();
            }, this.changeInterval);
        },
        getDepth(i) {
            return map(0, this.currentQuestions.length, this.minDepthSize, this.maxDepthSize, i);
        },
        onMouseOverBuuble(item) {
            if (!this.mouseFocus)
                this.mouseFocus = item;
        },
        onMouseLeaveBuuble(item) {
            if (this.mouseFocus === item) {
                this.mouseFocus = null;
            }
        },
    },
    computed: {
        ...mapGetters({
            allQuestions: 'getAllCloudQuestions',
            isLoading: 'getQuestionsIsLoading',
            selectedQuestion: 'getSelectedQuestion',
        }),
    },
    watch: {
        allQuestions: function(val) {
            if (!this.isInizalized)
                this.initCloud(val);
        }
    }
};
</script>

<template>
    <div class="question-cloud">
        <section ref="cloudContainer" class="question-cloud__section">
            <transition name="fade-delayed" mode="out-in">
                <div class="question-cloud__cloud" v-if="!isLoading && isInizalized">
                    <transition-group name="zoom">
                        <div 
                            class="question-cloud__bubble" 
                            v-for="(bubble, i) in currentQuestions" 
                            v-bind:key="bubble.id"
                            v-bind:class="{
                                'question-cloud__bubble--focussed': mouseFocus === bubble, 
                                'question-cloud__bubble--de-focussed': mouseFocus && mouseFocus !== bubble
                            }"
                            v-bind:style="getBubblePos(bubble.pos, i)">
                                <cloud-bubble 
                                    class="bubble" 
                                    v-bind:data="bubble" 
                                    v-bind:depthFactor="getDepth(i)"
                                    v-bind:transitionDuration="changeInterval"
                                    v-bind:movementRadius="bubbleMovementRadius"
                                    v-on:mouseOver="onMouseOverBuuble"
                                    v-on:mouseLeave="onMouseLeaveBuuble">
                                </cloud-bubble>
                        </div>
                    </transition-group>
                </div>
            </transition>
            <load-indicator v-if="isLoading" />
        </section>
    </div>
</template>

<style lang="scss" scoped>
.question-cloud {
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    display: flex;
    justify-content: center;
    align-items: center;
}

.question-cloud__section {
    position: relative;
    width: 100%; 
    max-width: 128rem;
    height: calc((var(--vh, 1vh) * 100) - 11.2rem);
    max-height: 128rem;
    margin: 5.6rem auto;
    display: flex;
    justify-content: center;
    align-items: center;

    @include breakpoint('xs-down') {
        height: calc((var(--vh, 1vh) * 100) - 3.2rem);
        margin: 1.6rem auto;
    }
}
.question-cloud__cloud {
    width: 100%; height: 100%;
}
.question-cloud__background {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 130vh;
    background: url('../assets/images/cloud-background.jpg') no-repeat center / cover;
    z-index: -1;
}
.question-cloud__bubble {
    position: absolute;
    z-index: 2;
    transition: 
        transform 200ms cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 300ms linear;
}
.question-cloud__bubble--focussed {
    transform: scale(1.1);
    z-index: 2;
}
.question-cloud__bubble--de-focussed {
    opacity: .5;
}
.question-cloud__bubble__scaler {
    transition: transform 20000ms;
}

.zoom-enter-active, .zoom-leave-active {
    transition: transform 5000ms cubic-bezier(0.645, 0.045, 0.355, 1),
                opacity 750ms linear;
}
.zoom-enter, .zoom-leave-to {
    transform: scale(0);
    opacity: 0;
}

.fade-delayed-enter-active, .fade-delayed-leave-active {
    transition: opacity 1000ms 300ms linear;
}
.fade-delayed-enter, .fade-leave-to {
    opacity: 0;
}
</style>
